// The Morales marks, from claude/18-design-system.md ("Streamline, Daylight"). Gold on the header ground.
// Colors come through CSS variables so the same components print on white paper (see styles.css, @media print).
import type { SVGProps } from 'react';

type Props = SVGProps<SVGSVGElement>;

/** The oak: heraldic round canopy of circles with four diamond cut-outs, thick trunk, three roots. */
export const OakMark = ({ className, ...p }: Props) => (
  <svg viewBox="0 0 100 100" className={`mark ${className ?? ''}`} aria-hidden focusable={false} {...p}>
    <g fill="var(--gold)">
      <circle cx="50" cy="40" r="22" />
      <circle cx="31" cy="50" r="14" />
      <circle cx="69" cy="50" r="14" />
      <circle cx="35" cy="28" r="13" />
      <circle cx="65" cy="28" r="13" />
      <circle cx="50" cy="20" r="12" />
      <circle cx="24" cy="40" r="10" />
      <circle cx="76" cy="40" r="10" />
      <path d="M45 92L55 92L53.5 58L46.5 58Z" />
    </g>
    <g fill="var(--mark-cut, var(--bg-head))">
      <path d="M38 36L41 40L38 44L35 40Z" />
      <path d="M50 26L53 30L50 34L47 30Z" />
      <path d="M62 36L65 40L62 44L59 40Z" />
      <path d="M50 46L53 50L50 54L47 50Z" />
    </g>
    <g fill="none" stroke="var(--gold)" strokeWidth="4" strokeLinecap="round">
      <path d="M50 90Q40 90 30 97M50 90Q60 90 70 97M50 90V97" />
    </g>
  </svg>
);

/** The rule: double gold hairline with the lozenge, at the bottom of every header and under printed titles.
 *  The hairlines are CSS (so they stay 1 px at any width); only the lozenge is drawn. */
export const DecoRule = ({ className }: { className?: string }) => (
  <span className={`rule ${className ?? ''}`} aria-hidden>
    <span className="rule-line" />
    <svg viewBox="88 0 64 16" width="64" height="16" focusable={false}>
      <g fill="none" stroke="var(--gold)" strokeWidth="1">
        <path d="M120 1L128 8L120 15L112 8Z" />
        <path d="M120 4L124 8L120 12L116 8Z" />
        <path d="M88 8L104 2L136 2L152 8L136 14L104 14Z" />
      </g>
    </svg>
    <span className="rule-line" />
  </span>
);

/** The diamond marker: filled when active (bottom nav, progress steps), empty otherwise. */
export const Diamond = ({ filled = false, className, ...p }: Props & { filled?: boolean }) => (
  <svg viewBox="0 0 24 24" className={`diamond ${className ?? ''}`} aria-hidden focusable={false} {...p}>
    <path d="M12 2L22 12L12 22L2 12Z" fill={filled ? 'currentColor' : 'none'} stroke="currentColor" strokeWidth="1.8" />
  </svg>
);

/** Wordmark and subtitle. Brand names are not translated. */
export const Wordmark = () => (
  <span className="wordmark">
    <span className="wordmark-name">Morales Produce</span>
    <span className="wordmark-sub">Fresh for Less · Bernalillo, New Mexico</span>
  </span>
);
